import { useParams } from "react-router-dom";
import BroadcasterView from "./../components/BroadcasterView.react";


export default function BroadcasterViewRoute(): React$Element<any> {
  let params = useParams();
  return <BroadcasterView sessionId={params.sessionId} />;
}
